<template>
<el-container>
  <el-main>
    <div class="login">
      <div class="login-logo"></div>
      <div class="login-form">
        <h3>伊颂婚恋管理平台</h3>
        <el-form label-position="top" :disabled="formDisabled">
          <el-form-item>
            <el-input v-on:keyup.enter.native="dologin()" v-model="loginForm.username" prefix-icon="el-icon-user"
              placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-on:keyup.enter.native="dologin()" v-model="loginForm.password" type="password"
              prefix-icon="el-icon-lock" placeholder="请输入密码" show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="loginForm.savePassword" @change="onSaveChange">记住密码</el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button style="width:100%" type="primary" @click="dologin">登陆</el-button>
          </el-form-item>
        </el-form>
        <!-- 首页已官网化，登录页不再占据 /，补一个回官网的入口 -->
        <div class="login-back">
          <router-link to="/">← 返回伊颂官网</router-link>
        </div>
      </div>
    </div>
  </el-main>
  </el-container>
</template>

<script>
  import {
    httpRequest,
    aesEncrypt,
    aesDecrypt
  } from '@/utils/app';
  import Cookie from 'js-cookie';
  export default {
    data() {
      return {
        loginForm: {
          username: '',
          password: '',
          // 默认不记住密码，仅当管理员主动勾选并在登录成功后才写入本地
          savePassword: false
        },
        formDisabled: false
      }
    },
    mounted() {
      // 回填已记住的登录信息
      this.loadSavedLogin()
      // 回车键登录
      const that = this
      document.onkeypress = function(e) {
        var keycode = document.all ? event.keyCode : e.which
        if (keycode === 13) {
          that.dologin()
          return false
        }
      }
    },
    methods: {
      dologin: function() {
        this.formDisabled = true
        if (this.loginForm.username.trim() === '' || this.loginForm.password.trim() === '') {
          this.$message({
            type: 'error',
            message: '请输入管理员帐号和密码'
          })

          this.formDisabled = false

          return
        }
        const that = this
        const params = {
          action: 'admin_login',
          username: this.loginForm.username,
          password: aesEncrypt(this.loginForm.password)
        }

        httpRequest(params, 'POST')
          .then(response => {
            if (response.error) {
              that.$message({
                type: 'error',
                message: response.msg
              })

              this.formDisabled = false

              return
            }
            that.$message({
              type: 'success',
              message: '登录成功!',
              onClose: function() {
                Cookie.set('admin', aesEncrypt(JSON.stringify(response.data)), {
                  expires: 7
                })
                // 记住 / 清除登录信息
                that.saveLoginInfo()
                document.onkeypress = null
                that.$router.push({
                  path: '/manage/'
                })
              }
            })
          })
      },

      /** 取消勾选时立即清除已记住的登录信息，避开旧数据残留下次又被回填 */
      onSaveChange(checked) {
        if (!checked) {
          localStorage.removeItem('adminLogin')
        }
      },

      /** 从 localStorage 回填已记住的登录信息（密码以 AES 解密还原） */
      loadSavedLogin() {
        try {
          const saved = localStorage.getItem('adminLogin')
          if (!saved) return
          const data = JSON.parse(saved)
          if (data && data.savePassword) {
            this.loginForm.username = data.username || ''
            this.loginForm.password = data.password ? aesDecrypt(data.password) : ''
            this.loginForm.savePassword = true
          }
        } catch (e) {
          // 解析异常时忽略，不影响正常登录
        }
      },

      /** 根据复选框状态保存或清除登录信息（密码加密后存储） */
      saveLoginInfo() {
        if (this.loginForm.savePassword) {
          localStorage.setItem('adminLogin', JSON.stringify({
            username: this.loginForm.username,
            password: aesEncrypt(this.loginForm.password),
            savePassword: true
          }))
        } else {
          localStorage.removeItem('adminLogin')
        }
      }
    }
  }
</script>

<style scoped>
  .el-main {
    height: 100vh;
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: relative;
    overflow: hidden;
    /* 柔和粉色基底渐变（加深版），带缓慢流动动画 */
    background: linear-gradient(135deg, #ffc8d9 0%, #ffa8c0 30%, #f285a5 60%, #d95783 100%);
    background-size: 300% 300%;
    animation: gradientShift 12s ease-in-out infinite;
  }

  /* 光斑 1 - 右上大型柔光（白色高光，避开登录框左侧图片区域） */
  .el-main::before {
    content: '';
    position: absolute;
    top: -15%;
    right: -10%;
    width: 60vw;
    height: 60vw;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.95) 0%, rgba(255, 220, 230, 0.55) 40%, transparent 72%);
    border-radius: 50%;
    filter: blur(50px);
    animation: floatOrb1 13s ease-in-out infinite;
    pointer-events: none;
    z-index: 0;
  }

  /* 光斑 2 - 左下玫瑰光晕 */
  .el-main::after {
    content: '';
    position: absolute;
    bottom: -20%;
    left: -10%;
    width: 50vw;
    height: 50vw;
    background: radial-gradient(circle, rgba(250, 172, 212, 0.55) 0%, rgba(219, 52, 110, 0.22) 45%, transparent 72%);
    border-radius: 50%;
    filter: blur(70px);
    animation: floatOrb2 19s cubic-bezier(0.45, 0.05, 0.55, 0.95) infinite;
    pointer-events: none;
    z-index: 0;
  }

  /* 背景渐变 2D 环形流动 */
  @keyframes gradientShift {
    0%   { background-position: 0% 50%; }
    25%  { background-position: 50% 0%; }
    50%  { background-position: 100% 50%; }
    75%  { background-position: 50% 100%; }
    100% { background-position: 0% 50%; }
  }

  /* 光斑 1：翻滚漂移（位移 + 缩放 + 旋转，4 段不规则路径） */
  @keyframes floatOrb1 {
    0%   { transform: translate(0, 0) scale(1) rotate(0deg);            opacity: 0.55; }
    25%  { transform: translate(-14vw, 8vh) scale(1.25) rotate(90deg);   opacity: 0.9;  }
    50%  { transform: translate(-6vw, 18vh) scale(0.85) rotate(180deg);  opacity: 1;    }
    75%  { transform: translate(10vw, 6vh) scale(1.15) rotate(270deg);    opacity: 0.7;  }
    100% { transform: translate(0, 0) scale(1) rotate(360deg);            opacity: 0.55; }
  }

  /* 光斑 2：强脉冲呼吸 + 反向对角弹动（节奏与光斑1 区分） */
  @keyframes floatOrb2 {
    0%   { transform: translate(0, 0) scale(0.85);          opacity: 0.45; }
    30%  { transform: translate(12vw, -12vh) scale(1.45);   opacity: 1;    }
    60%  { transform: translate(20vw, 4vh) scale(1.0);      opacity: 0.7;  }
    100% { transform: translate(0, 0) scale(0.85);          opacity: 0.45; }
  }

  /* 尊重用户降低动效偏好 */
  @media (prefers-reduced-motion: reduce) {
    .el-main,
    .el-main::before,
    .el-main::after {
      animation: none;
    }
  }

  .login {
    display: flex;
    width: 600px;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 12px 40px 0 rgba(219, 52, 110, 0.18), 0 2px 12px 0 rgba(0, 0, 0, 0.06);
    position: relative;
    z-index: 1;
  }

  @media only screen and (max-width:767px) {
    .login {
      width: 80%;
      flex-direction: column;
    }
  }

  .login-logo {
    flex: 1;
    background: url('~@/assets/login_box.jpg') 50% 50% no-repeat;
    background-size: cover;
  }

  .login-form {
    flex: 1;
  }

  .login-form h3 {
    text-align: center;
    font-weight: 600;
    letter-spacing: 1px;
  }

  .el-form {
    margin: 15%;
  }

  .login-back {
    text-align: center;
    padding-bottom: 18px;
  }

  .login-back a {
    font-size: 12px;
    color: #999;
    text-decoration: none;
  }

  .login-back a:hover {
    color: #dc2380;
  }
</style>